// NOTE: 認証前画面のJavascriptを記述する
import * as customSelect2 from '../modules/customSelect2'
import $ from 'jquery';

customSelect2.init()

$('.login_content').css('visibility', 'visible')

// 2重サブミット対策
$('form').on('submit', function() {
  $(':submit', this).prop('disabled', true);
});